module.exports = __webpack_public_path__ + "static/challenge-524b3e2695baf09e14cfb9a1a16a4899.png";